export default "__VITE_ASSET__D974XSsJ__"